<app-breadcrumb [title]="'Change Password'"></app-breadcrumb>
<div class="container-fluid">
  <div class="row">
    <div class="col">
      <div class="card">
        <div class="card-header">{{title}}</div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <form [formGroup]="changePasswordForm" (ngSubmit)="save()">
                <div class="form-row">
                  <label for="email" class="col-md-4">Email</label>
                  <div class="col-md-8 mb-3">
                    <input MyInput formControlName="email" readonly type="text" class="form-control">
                    <my-error controlName="email" errorKey="required">email is required.</my-error>
                  </div>
                </div>
                <div class="form-row">
                  <label for="password" class="col-md-4">New Password</label>
                  <div class="col-md-8 mb-3">
                    <input type="password" class="form-control" MyInput formControlName="password" id="password">
                    <my-error controlName="password" errorKey="required">New Password is required.</my-error>
                    <my-error controlName="password" errorKey="minlength">New Password must be at least 6 characters.
                    </my-error>
                  </div>
                </div>
                <div class="form-row">
                  <label for="confirmPassword" class="col-md-4">Confirm Password</label>
                  <div class="col-md-8 mb-3">
                    <input type="password" class="form-control" MyInput formControlName="confirmPassword"
                      id="confirmPassword">
                    <my-error controlName="confirmPassword" errorKey="required">Confirm Password is required.</my-error>
                    <div class="invalid-feedback" style="display: block;"
                      *ngIf="changePasswordForm.get('confirmPassword').dirty && changePasswordForm.hasError('mismatch')">
                      Confirm password must match new password.
                    </div>
                  </div>
                </div>
                <button class="btn btn-primary mr-3" [disabled]="!changePasswordForm.valid || loading" type="submit">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="loading"></span>
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>